import React from 'react';
import { useNavigate } from 'react-router-dom';

function DeviceDetail() {
  const navigate = useNavigate();
  
  return (
    <div>
      <div className="page-header">
        <button className="btn btn-secondary" onClick={() => navigate('/devices')}>
          ← Back to Devices
        </button>
        <h1>Device Details</h1>
      </div>
      <div className="card">
        <h3>🚧 Coming Soon</h3>
        <p>Device detail page with complete information.</p>
      </div>
    </div>
  );
}

export default DeviceDetail;